const capitalize = (s?: string): string | undefined =>
  s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : undefined;

export default capitalize;
